import Animation from './Animation';
import './Heal.css';

export default class Heal extends Animation {

	constructor (master, entity) {

		super(master, 0);
		this.entity = entity;
		this.loadAudio("heal");
	}

	run () {

		var el = document.querySelector("#game-entity-" + this.entity + " .game-entity-main .game-entity-img-wrapper");
		if (el) {
			el.classList.add("heal-anim");
			setTimeout(() => el.classList.remove("heal-anim"), 900);
		}
	}
}